<app-legal-layout
  eyebrow="Rechtliches"
  title="Widerrufsbelehrung"
  lastUpdated="Mai 2026">

  <p>
    Diese Widerrufsbelehrung gilt für Verbraucher (Endkunden) im Sinne von § 13 BGB im Hinblick auf
  </p>
  <ul>
    <li>(a) den <strong>Nutzungsvertrag mit der Kulatrix UG</strong> (Plattformnutzung);</li>
    <li>
      (b) den <strong>Vertrag mit dem Handwerker</strong> über eine vermittelte Handwerksleistung,
      sofern dieser Vertrag im Wege des Fernabsatzes oder außerhalb von Geschäftsräumen geschlossen
      wird.
    </li>
  </ul>
  <p>Soweit nachstehend nicht anders gekennzeichnet, gilt die Belehrung für beide Verträge gleichermaßen.</p>

  <hr>

  <h2>Widerrufsrecht</h2>
  <p>
    Sie haben das Recht, binnen <strong>vierzehn Tagen</strong> ohne Angabe von Gründen diesen Vertrag
    zu widerrufen.
  </p>
  <p>Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsschlusses.</p>
  <p>Um Ihr Widerrufsrecht auszuüben, müssen Sie uns</p>

  <address class="cr-legal__address">
    <strong>Kulatrix UG (haftungsbeschränkt)</strong><br>
    Alarichstraße 18<br>
    42281 Wuppertal<br>
    Telefon: <a href="tel:+4915252629106">+49 152 52629106</a><br>
    E-Mail: <a href="mailto:info&#64;kulatrix.com">info&#64;kulatrix.com</a>
  </address>

  <p>
    – bzw. dem <strong>jeweiligen Handwerker</strong>, dessen Kontaktdaten Sie bei der Buchung sowie in
    „Mein Konto" einsehen können –
  </p>
  <p>
    mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief, Telefax oder E-Mail)
    über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das nachstehende
    Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
  </p>
  <p>
    Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des
    Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
  </p>

  <h2>Folgen des Widerrufs</h2>
  <p>
    Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten
    haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus
    ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, günstigste
    Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag
    zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist.
    Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen
    Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart;
    in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
  </p>

  <h2>Besonderheiten bei Dienst- und Werkleistungen (gilt für den Vertrag mit dem Handwerker)</h2>
  <p>
    Haben Sie verlangt, dass die Dienstleistung oder die Werkleistung
    <strong>während der Widerrufsfrist beginnen soll</strong>, so haben Sie uns bzw. dem Handwerker
    einen angemessenen Betrag zu zahlen, der dem Anteil der bis zu dem Zeitpunkt, zu dem Sie uns von
    der Ausübung des Widerrufsrechts hinsichtlich dieses Vertrags unterrichten, bereits erbrachten
    Leistungen im Vergleich zum Gesamtumfang der im Vertrag vorgesehenen Leistungen entspricht.
  </p>

  <h2>Erlöschen des Widerrufsrechts (Hinweis nach § 356 Abs. 4 und 5 BGB)</h2>
  <p>
    Bei Verträgen über die Erbringung von <strong>Dienstleistungen</strong> erlischt das Widerrufsrecht,
    wenn der Unternehmer (Handwerker) die Dienstleistung <strong>vollständig</strong> erbracht hat und
    mit der Ausführung der Dienstleistung erst begonnen hat, nachdem der Verbraucher dazu seine
    <strong>ausdrückliche Zustimmung</strong> gegeben hat und gleichzeitig seine Kenntnis davon bestätigt
    hat, dass er sein Widerrufsrecht bei vollständiger Vertragserfüllung durch den Unternehmer verliert.
  </p>
  <p>
    Bei Verträgen über die Erbringung <strong>digitaler Inhalte</strong>, die nicht auf einem
    körperlichen Datenträger geliefert werden, erlischt das Widerrufsrecht entsprechend, wenn der
    Unternehmer mit der Ausführung des Vertrags begonnen hat, nachdem der Verbraucher ausdrücklich
    zugestimmt hat und seine Kenntnis vom Erlöschen seines Widerrufsrechts bestätigt hat.
  </p>

  <hr>

  <h2>Muster-Widerrufsformular</h2>
  <blockquote>
    Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie
    es zurück.
  </blockquote>

  <p>An:</p>
  <address class="cr-legal__address">
    <strong>Kulatrix UG (haftungsbeschränkt)</strong><br>
    Alarichstraße 18<br>
    42281 Wuppertal<br>
    E-Mail: <a href="mailto:info&#64;kulatrix.com">info&#64;kulatrix.com</a>
  </address>

  <p>– bzw. an den jeweiligen Handwerker (Kontaktdaten siehe Buchungsbestätigung):</p>

  <hr>

  <p>Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über</p>
  <ul>
    <li>☐ die Nutzung der Plattform get-craftly.de</li>
    <li>☐ die folgende Handwerksleistung: <span class="cr-legal__form-line">&nbsp;</span></li>
  </ul>

  <p>Bestellt am (*) / erhalten am (*): <span class="cr-legal__form-line">&nbsp;</span></p>
  <p>Name des/der Verbraucher(s): <span class="cr-legal__form-line">&nbsp;</span></p>
  <p>Anschrift des/der Verbraucher(s): <span class="cr-legal__form-line">&nbsp;</span></p>
  <p>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier): <span class="cr-legal__form-line">&nbsp;</span></p>
  <p>Datum: <span class="cr-legal__form-line">&nbsp;</span></p>

  <p><em>(*) Unzutreffendes streichen.</em></p>

</app-legal-layout>
